$(document).ready(function() {
    if (typeof window.aireValidatorTranslation == 'undefined' || typeof window.translatorLang == 'undefined' || typeof window.Validator == 'undefined') {
        return;
    }
    $.each(window.aireValidatorTranslation, function(key, value) {
        window.Validator.setMessages(key, value);
    });
    window.Validator.useLang(window.translatorLang);
});
